import * as React from "react";
import { IValidation } from "@generation/core";
import { FileAbstractValidation } from "../../Validations/FileAbstractValidation";
import { FileErrorMessage } from "./FileErrorMessage";
import { HasFileMaxSizeValidation } from "../../Validations/HasMaxFileSizeValidation";
import { HasFileExtensionValidation } from "../../Validations/HasFileExtensionValidation";
import { HasFileMinSizeValidation } from "../../Validations/HasMinFileSizeValidation";
import { IsFileNotEmptyValidation } from "../../Validations/IsFileNotEmptyValidation";

interface IFileErrorMessageBlock {
  label: string;
  file: File;
  validate: IValidation[];
}

export const FileErrorMessageBlock = (props: IFileErrorMessageBlock) => {
  const handleValidator = (validation: FileAbstractValidation) => {
    if (!props.validate) {
      return null;
    }

    if (!validation.isValidFile(props.file)) {
      return <FileErrorMessage validation={validation} label={props.label} />;
    }
    return null;
  };

  function findFileRowValidations(value: IValidation | null | undefined): value is FileAbstractValidation {
    if (value instanceof IsFileNotEmptyValidation || 
        value instanceof HasFileMinSizeValidation ||
        value instanceof HasFileMaxSizeValidation ||
        value instanceof HasFileExtensionValidation) {
      return true;
    }
    return false;
  }

  let result: JSX.Element | null = null;
  props.validate.filter(findFileRowValidations).forEach((validation) => {
    const resultValidate = handleValidator(validation);
    if (!result && resultValidate) {
      result = resultValidate;
    }
  });
  return result;
};
